module.exports = __webpack_public_path__ + "img/lens-167-minus-11.72f95345.png";